;(function () {
  const selectors = {
    facebookShareBtn: '[data-facebook-share]',
    linkedinShareBtn: '[data-linkedin-share]',
    twitterShareBtn: '[data-twitter-share]',
    pinterestShareBtn: '[data-pinterest-share]'
  }

  const attachTwitterShareListeners = () => {
    const twitterShareBtns = document.querySelectorAll(
      selectors.twitterShareBtn
    )

    if (!twitterShareBtns.length) {
      return
    }

    function handleClick() {
      const shareUrl = this.dataset.shareUrl
      const shareTitle = this.dataset.shareTitle

      if (!shareUrl) {
        return
      }

      window.open(
        `http://twitter.com/share?&${
          shareTitle && shareTitle.trim().length
            ? 'text=' + shareTitle + '&'
            : ''
        }url=${shareUrl}&hashtags=superfoods`,
        '_blank',
        'width=550, height=399, scrollbars=no'
      )

      return false
    }

    for (let i = 0; i < twitterShareBtns.length; i++) {
      twitterShareBtns[i].addEventListener('click', handleClick)
    }
  }

  const attachFacebookShareListeners = () => {
    const facebookShareBtns = document.querySelectorAll(
      selectors.facebookShareBtn
    )

    if (!facebookShareBtns.length) {
      return
    }

    function handleClick() {
      const shareUrl = this.dataset.shareUrl

      if (!shareUrl) {
        return
      }

      window.open(
        `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`,
        '_blank',
        'width=555, height=551, scrollbars=no'
      )

      return false
    }

    for (let i = 0; i < facebookShareBtns.length; i++) {
      facebookShareBtns[i].addEventListener('click', handleClick)
    }
  }

  const attachLinkedinShareListeners = () => {
    const linkedinShareBtns = document.querySelectorAll(
      selectors.linkedinShareBtn
    )

    if (!linkedinShareBtns.length) {
      return
    }

    function handleClick() {
      const shareUrl = this.dataset.shareUrl

      if (!shareUrl) {
        return
      }

      window.open(
        `https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`,
        '_blank',
        'width=555, height=551, scrollbars=no'
      )
      return false
    }

    for (let i = 0; i < linkedinShareBtns.length; i++) {
      linkedinShareBtns[i].addEventListener('click', handleClick)
    }
  }

  const attachPinterestShareListeners = () => {
    const pinterestShareBtns = document.querySelectorAll(
      selectors.pinterestShareBtn
    )

    if (!pinterestShareBtns.length) {
      return
    }

    function handleClick() {
      const shareUrl = this.dataset.shareUrl

      if (!shareUrl) {
        return
      }

      window.open(
        `https://pinterest.com/pin/create/button/?url=${shareUrl}`,
        '_blank',
        'width=555, height=551, scrollbars=no'
      )

      return false
    }

    for (let i = 0; i < pinterestShareBtns.length; i++) {
      pinterestShareBtns[i].addEventListener('click', handleClick)
    }
  }

  window.addEventListener('load', function () {
    attachTwitterShareListeners()
    attachFacebookShareListeners()
    attachLinkedinShareListeners()
    attachPinterestShareListeners()
  })
})()
